"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductImage = void 0;
const react_1 = __importDefault(require("react"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const __1 = require("../");
const variation_context_container_1 = require("../variation-context-container");
const ProductImage = (props) => {
    const { currentVariation } = (0, variation_context_container_1.useVariationContext)();
    const getImageFromVisualVariations = (variationImages, values) => {
        const image = variationImages.find((variationImage) => {
            return (0, isEqual_1.default)(variationImage.visualDimensionIds, values);
        });
        return image ? image : undefined;
    };
    let imageUrl = props.mediaSrcUrl;
    if (props.variationImages) {
        const newImage = getImageFromVisualVariations(props.variationImages, currentVariation);
        const newImageUrl = (newImage === null || newImage === void 0 ? void 0 : newImage.hiResImage) !== '' ? newImage === null || newImage === void 0 ? void 0 : newImage.hiResImage : newImage.lowResImage;
        imageUrl = newImageUrl ? newImageUrl : imageUrl;
    }
    return react_1.default.createElement(__1.Media, Object.assign({}, props, { mediaSrcUrl: imageUrl, objectFit: "scale-down", "data-cy": "product-image" }));
};
exports.ProductImage = ProductImage;
